import React, { useState } from "react";
import { Divider, Menu, MenuItem } from "@mui/material";
import "./ActionMenu.scss";

const ActionMenu = ({
  label = "record",
  actions = [],
  triggerClassName = "",
  contentClassName = "",
  side = "bottom",
  align = "end",
}) => {
  const [anchorElement, setAnchorElement] = useState(null);
  const isOpen = Boolean(anchorElement);

  const closeMenu = () => setAnchorElement(null);

  const selectAction = (action) => {
    closeMenu();
    action.onSelect?.();
  };

  return (
    <span className="action-menu">
      <button
        type="button"
        className={`action-menu__trigger ${triggerClassName}`.trim()}
        aria-label={`Actions for ${label}`}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        onClick={(event) => {
          event.stopPropagation();
          setAnchorElement(event.currentTarget);
        }}
      >
        <i className="bx bx-dots-vertical-rounded" aria-hidden="true" />
      </button>
      <Menu
        anchorEl={anchorElement}
        open={isOpen}
        onClose={closeMenu}
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{
          vertical: side === "top" ? "top" : "bottom",
          horizontal: align === "end" ? "right" : "left",
        }}
        transformOrigin={{
          vertical: side === "top" ? "bottom" : "top",
          horizontal: align === "end" ? "right" : "left",
        }}
        slotProps={{
          list: { "aria-label": `Actions for ${label}` },
          paper: {
            className: `action-menu__content ${contentClassName}`.trim(),
          },
        }}
        disableScrollLock
      >
        {actions.filter(Boolean).map((action, index) => (
          <React.Fragment key={action.key || action.label || index}>
            {action.separatorBefore && (
              <Divider className="action-menu__separator" />
            )}
            <MenuItem
              className={`action-menu__item ${action.className || ""}`.trim()}
              disabled={action.disabled}
              onClick={(event) => {
                event.stopPropagation();
                selectAction(action);
              }}
            >
              <span className="action-menu__icon" aria-hidden="true">
                {action.icon}
              </span>
              <span className="action-menu__label">{action.label}</span>
            </MenuItem>
          </React.Fragment>
        ))}
      </Menu>
    </span>
  );
};

export default ActionMenu;
